/** Chip "Em breve" pra recursos sem backend. */
export default function BadgeEmBreve({ className = '' }: { className?: string }) {
  return (
    <span className={`inline-flex items-center px-1.5 py-0.5 text-[11px] font-semibold uppercase tracking-wide bg-surface-2 text-tx-3 rounded-iris-sm ${className}`}>
      Em breve
    </span>
  );
}
